import React from 'react'
import { injectIntl } from 'react-intl'
import { QueryClient, QueryClientProvider, } from '@tanstack/react-query'
import CopycheckerElement from './CopycheckerElement'

const queryClient = new QueryClient()

function Copychecker() {
  return (
    <QueryClientProvider client={queryClient}>
      <CopycheckerElement />
    </QueryClientProvider>
  )
}

export default injectIntl(Copychecker)
